import React, { useEffect, useState } from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getAccessTokenApi } from '../../../../api/auth';
import { METHOD_GET } from '../../../../utils/constants';
import { fetchApi } from '../../../../helpers/fetch';
import SupplierRoutesTable from '../../../../components/Admin/Suppliers/SupplierRoutesTable/SupplierRoutesTable';
import BackButton from '../../../../components/General/BackButton/BackButton';

export default function SuplierRoutes() {
  let { supplierId } = useParams();
  const token = getAccessTokenApi();
  const [supplier, setSupplier] = useState({});

  useEffect(() => {
    const config = {
      method: METHOD_GET,
      url: `Supplier/${supplierId}`,
      data: null,
      token,
    };
    fetchApi(config)
      .then((response) => {
        // console.log(response, 'response sup');
        if (response) {
          let supp = response.result;
          setSupplier(supp);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [supplierId, token]);
  return (
    <Layout>
      <GreetingsTop />

      <HeaderTop supplier={supplier} />

      <div className="clients__container">
        <SupplierRoutesTable supplier={supplier} />
      </div>
    </Layout>
  );
}

function HeaderTop({ supplier }) {
  const { Title } = Typography;

  return (
    <div className="clients__container">
      <Row xs={23} className="header-top">
        <Col xs={19} className="header-top__left">
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Rutas {supplier.name}
          </Title>
        </Col>
        <Col xs={5}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/proveedores'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
